import { P2GBox } from '@parcel2go/core-ui';

export const KnowYourCustomerApplicationTimer = ({ seconds }: { seconds: number }) => {
  if (seconds > 60) {
    return (
      <P2GBox>
        Please upload the required documents within <strong>{Math.ceil(seconds / 60)} minute(s)</strong>. If you miss
        the deadline, you'll need to delete and create a new application.
        <p>
          <strong>Accepted File Types</strong>: PDF, JPEG. <strong>Max file size</strong>: 1MB.
        </p>
      </P2GBox>
    );
  }

  return (
    <P2GBox>
      Please upload the required documents within <strong>{seconds} seconds</strong>. If you miss the deadline, you'll
      need to delete and create a new application.
      <p>
        <strong>Accepted File Types</strong>: PDF, JPEG. <strong>Max file size</strong>: 1MB.
      </p>
    </P2GBox>
  );
};
